import React from 'react';
import { styles } from './LimitedRunPromoTag.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';

type LabelConfig = {
  style: string;
  labelOverride?: string;
};

export type LimitedRunPromoProps = {
  label: string;
  isSmallSize?: boolean;
};

export const LimitedRunPromoTag = ({ label }: LimitedRunPromoProps) => {
  const labelVariations: { [key: string]: LabelConfig } = {
    'Selling fast': { style: styles.sellingFast },
    'Running out': { style: styles.runningOut },
    'Nearly gone': { style: styles.nearlyGone },
    'Sold out': { style: styles.soldOut },
  };
  const selectedVariation = labelVariations[label];
  return (
    <>
      <CrazyFont variant="withShadowAndOutline">
        <div className={classNames([styles.base, selectedVariation?.style])}>{label}</div>
      </CrazyFont>
    </>
  );
};
